import { ReactNode } from 'react';
import styled from 'styled-components';
import {
  autoUpdate,
  flip,
  offset,
  size,
  useDismiss,
  useFloating,
  useInteractions,
} from '@floating-ui/react';
import { MiddlewareState } from '@floating-ui/dom';
import { floatingComponentStyles } from '../../../../styles/shareableStyles';

interface IProps {
  reference: HTMLElement | null;
  children: ReactNode;
  onClose: () => void;
}

const Wrapper = styled.div`
  ${floatingComponentStyles};
`;

const SuggestionsPopover = ({ children, reference, onClose }: IProps) => {
  const { floatingStyles, refs, context } = useFloating({
    // Even though we control when Popover is opened or not from the parent,
    // We need open prop to be always true in order for dismiss to
    // work properly
    open: true,
    onOpenChange: (open) => {
      if (!open) {
        onClose();
      }
    },
    elements: {
      reference,
    },
    middleware: [
      // Match reference width
      size({
        apply({ rects, elements }: MiddlewareState) {
          Object.assign(elements.floating.style, {
            minWidth: `${rects.reference.width}px`,
          });
        },
      }),
      offset(5),
      flip(),
    ],
    whileElementsMounted: autoUpdate,
    strategy: 'fixed',
    placement: 'bottom',
  });

  const dismiss = useDismiss(context);
  const { getFloatingProps } = useInteractions([dismiss]);

  return (
    <div ref={refs.setFloating} style={floatingStyles} {...getFloatingProps()}>
      <Wrapper>{children}</Wrapper>
    </div>
  );
};

export default SuggestionsPopover;
